import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

/**
 * One row in the Detalle Venta hub: an icon + label on the left and any
 * number of actions on the right. When `disabled`, the whole row dims and
 * the actions don't fire — used to gate later-stage sections (Pagos,
 * Facturación, Despacho, Puesta en marcha) until the venta advances.
 */
export function StageCard({
  icon: Icon,
  title,
  disabled = false,
  disabledHint,
  children,
}: {
  icon: LucideIcon;
  title: string;
  disabled?: boolean;
  disabledHint?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 rounded-2xl border bg-card px-5 py-4 transition-colors',
        disabled && 'opacity-60',
      )}
      title={disabled ? disabledHint : undefined}
    >
      <div className="flex items-center gap-3">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-muted text-foreground">
          <Icon className="h-5 w-5" aria-hidden />
        </span>
        <h2 className="text-lg font-semibold tracking-tight text-foreground">{title}</h2>
      </div>
      <div className={cn('flex flex-wrap items-center gap-2', disabled && 'pointer-events-none')}>
        {children}
      </div>
    </div>
  );
}
